<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Therfield">

<svelte:fragment slot="blurb">
<InfoSection src="pics/therfield.jpg" alt="Therfield">
<p>Therfield is known as a very small village that is locally famous for its church, chapel and pub. The Nature Reserve of Therfield Heath lies a mile to the north of the village</p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="foodanddrink">
<InfoSection id="fox_and_duck" Title="The Fox and Duck" src="pics/therfield-fox-and-duck.jpg" alt="A busy day at the Fox and Duck">
<p>The Fox and Duck is a very popular pub. It has great food and a lovely green, but some times service can be a little slow when very busy. I would say this is my 3rd favourite place to eat in the local area. You can walk here from Royston heath.</p>
<p><a href="https://thefoxandduck.co.uk/" target="new">{@html Icon("external-link","small")} Website</a></p>
</InfoSection>

</svelte:fragment>
</InfoPage>
